module.exports = __webpack_public_path__ + "static/media/banner-who-its-for.ac293347.png";